import axios from "axios";

export default axios.create({
  baseURL: "https://api.smartdevagency.it/api/v1/",
  headers: {
    'Content-Type': 'application/json',
  }
});
